import { lazy, Suspense, useMemo } from "react"
import { Outlet } from "react-router"
import { QueryClient } from "@tanstack/react-query"
import { reportLoader } from "@/feature/report/api/loader.ts"
import { SkeletonPageLoading as ReportBusinessPlanPageSkeleton } from "@/feature/report/business-plan/components/SkeletonPageLoading.tsx"
// import { companyLoader } from "@/feature/company/api/loader.ts"
import { importOrReload } from "@/lib/utils/dynamic-import.ts"

type RouterProps = {
  queryClient: QueryClient
}
const LazyBusinessPlanReportRoute = lazy(() =>
  importOrReload(() =>
    import(`./business-plan/route.tsx`).then(mod => ({
      default: mod.BusinessPlanReportRoute,
    }))
  )
)

const LazyReportIndexRoute = lazy(() =>
  importOrReload(() =>
    import(`./route.tsx`).then(mod => ({
      default: mod.ReportIndexRoute,
    }))
  )
)

export const useReportRoutes = ({ queryClient }: RouterProps) => {
  const businessPlanRoutes = useMemo(
    () => [
      {
        path: `business-plan`,
        // loader: companyLoader(queryClient),
        element: <Outlet />,
        hydrateFallbackElement: <ReportBusinessPlanPageSkeleton />,
        children: [
          {
            index: true,
            loader: reportLoader(queryClient, {
              presentationType: `business_plan`,
              periodType: `historical`,
              slides: [],
            }),
            element: (
              <Suspense fallback={<ReportBusinessPlanPageSkeleton />}>
                <LazyBusinessPlanReportRoute />
              </Suspense>
            ),
          },
        ],
      },
    ],
    [queryClient]
  )
  const salesRoutes = useMemo(() => [], [])
  const pitchDeckRoutes = useMemo(() => [], [])

  return useMemo(
    () => [
      {
        path: `report`,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <LazyReportIndexRoute />,
          },
          ...businessPlanRoutes,
          ...salesRoutes,
          ...pitchDeckRoutes,
        ],
      },
    ],
    [businessPlanRoutes, salesRoutes, pitchDeckRoutes]
  )
}
